import { isNumber, minBy } from 'lodash';
import { ActivityType, EcoZone, Source, type Trip } from '../types';
import { Timestamp } from '../services/Timestamp';

const ordersActivities = [ActivityType.Sailing, ActivityType.Berthing, ActivityType.Shifting];
const artificialActivities = [ActivityType.Loading, ActivityType.SignalLost];

export function isUnderOrdersActivity(activity?: ActivityType): boolean {
  return ordersActivities.includes(activity);
}

export function isArtificialActivity(activity?: ActivityType): boolean {
  return artificialActivities.includes(activity);
}

export function mapEcoScoreToEcoZone(ecoScore: number): EcoZone {
  if (!isNumber(ecoScore)) {
    return null;
  }

  if (ecoScore <= 69) {
    return EcoZone.bad;
  }

  if (ecoScore >= 70 && ecoScore <= 89) {
    return EcoZone.neutral;
  }

  return EcoZone.good;
}

export function isTugTrip(trip: Trip): boolean {
  return trip.type.toLowerCase() === 'repositioning';
}

export const getStartTimeFromTrip = (trip: Trip): Timestamp => {
  const activities = trip.jobs.filter(j => j.source !== Source.Helm).flatMap(job => job.activities);
  const underOrdersActivities = activities
    .filter(activity => isUnderOrdersActivity(activity.activity as ActivityType))
    .sort(activity => activity.timestampStart);
  const firstActivityTimestamp = minBy(underOrdersActivities, a => a.timestampStart)?.timestampStart;

  return Timestamp.fromSeconds(firstActivityTimestamp ?? trip.timestampStart);
};
